<template>
  <div id="components-layout-demo-basic">
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <defs>
        <symbol id="icon-print" viewBox="0 0 512 512">
          <g><g><path d="M329.956,399.834H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911c9.425,0,17.067-7.641,17.067-17.067S339.381,399.834,329.956,399.834z" /></g></g>
          <g><g><path d="M329.956,346.006H182.044c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h147.911c9.425,0,17.067-7.641,17.067-17.067S339.381,346.006,329.956,346.006z" /></g></g>
          <g><g><path d="M472.178,133.907h-54.303V35.132c0-9.425-7.641-17.067-17.067-17.067H111.192c-9.425,0-17.067,7.641-17.067,17.067v98.775H39.822C17.864,133.907,0,151.772,0,173.73v171.702c0,21.958,17.864,39.822,39.822,39.822h54.306v91.614c0,9.425,7.641,17.067,17.067,17.067h289.61c9.425,0,17.067-7.641,17.067-17.067v-91.614h54.306c21.958,0,39.822-17.864,39.822-39.822V173.73C512,151.773,494.136,133.907,472.178,133.907z M128.258,52.199h255.483v81.708H128.258V52.199z M383.738,459.801H128.262c0-3.335,0-135.503,0-139.628h255.477C383.738,324.402,383.738,456.594,383.738,459.801z M400.808,234.122h-43.443c-9.425,0-17.067-7.641-17.067-17.067s7.641-17.067,17.067-17.067h43.443c9.425,0,17.067,7.641,17.067,17.067S410.234,234.122,400.808,234.122z" /></g></g>
        </symbol>
        <symbol id="icon-submit" viewBox="0 0 489.4 489.4">
          <g><g><path d="M382.4,422.75h-79.1H282h-4.6v-106.1h34.7c8.8,0,14-10,8.8-17.2l-67.5-93.4c-4.3-6-13.2-6-17.5,0l-67.5,93.4c-5.2,7.2-0.1,17.2,8.8,17.2h34.7v106.1h-4.6H186H94.3c-52.5-2.9-94.3-52-94.3-105.2c0-36.7,19.9-68.7,49.4-86c-2.7-7.3-4.1-15.1-4.1-23.3c0-37.5,30.3-67.8,67.8-67.8c8.1,0,15.9,1.4,23.2,4.1c21.7-46,68.5-77.9,122.9-77.9c70.4,0.1,128.4,54,135,122.7c54.1,9.3,95.2,59.4,95.2,116.1C489.4,366.05,442.2,418.55,382.4,422.75z" /></g></g>
        </symbol>
        <symbol id="icon-delete" viewBox="0 0 24 24">
          <g id="Layer_2" data-name="Layer 2"><path d="m12 1a11 11 0 1 0 11 11 11.013 11.013 0 0 0 -11-11zm4.242 13.829a1 1 0 1 1 -1.414 1.414l-2.828-2.829-2.828 2.829a1 1 0 0 1 -1.414-1.414l2.828-2.829-2.828-2.829a1 1 0 1 1 1.414-1.414l2.828 2.829 2.828-2.829a1 1 0 1 1 1.414 1.414l-2.828 2.829z" /></g>
        </symbol>
        <symbol id="icon-edit" viewBox="0 0 512.009 512.00">
          <g><g><path d="M397.96,330.099c-13.755,0-24.872,11.118-24.872,24.872v78.125c0,13.73-11.143,24.872-24.872,24.872H74.617c-13.73,0-24.872-11.143-24.872-24.872V109.754c0-13.73,11.143-24.872,24.872-24.872h144.509c13.754,0,24.872-11.118,24.872-24.872c0-13.754-11.118-24.872-24.872-24.872H74.617C33.478,35.136,0,68.615,0,109.754v323.342c0,41.139,33.478,74.617,74.617,74.617h273.597c41.139,0,74.617-33.453,74.617-74.617v-78.124C422.832,341.217,411.714,330.099,397.96,330.099z" /></g></g>
          <g><g><path d="M484.193,31.977c-18.057-18.057-41.637-27.161-65.39-27.658c-24.997-0.547-50.143,8.506-69.046,27.434L181.37,200.14c-24.574,24.674-38.105,57.406-38.105,92.177v55.714c0,13.754,11.118,24.872,24.872,24.872h55.714c34.772,0,67.504-13.531,92.202-38.13l168.163-168.163C521.277,129.527,521.277,69.087,484.193,31.977z M280.91,299.581c-15.247,15.197-35.543,23.579-57.057,23.579H193.01v-30.842c0-21.515,8.382-41.811,23.554-57.033l111.006-111.006l64.32,64.32L280.91,299.581z M449.023,131.467L427.06,153.43l-64.32-64.32l21.962-21.962c17.759-17.759,46.611-17.709,64.32,0C466.732,84.881,466.732,113.733,449.023,131.467z" /></g></g>
        </symbol>
        <symbol id="icon-copy" viewBox="0 0 512 512">
          <g id="copy"><path d="M85.3,469.3h256c23.5,0,42.7-19.1,42.7-42.7V384h42.7c23.5,0,42.7-19.1,42.7-42.7v-256c0-23.5-19.1-42.7-42.7-42.7h-256c-23.5,0-42.7,19.1-42.7,42.7V128H85.3c-23.5,0-42.7,19.1-42.7,42.7v256C42.7,450.2,61.8,469.3,85.3,469.3z M85.4,170.7h255.9v256h-256L85.4,170.7z"/></g>
        </symbol>
        <symbol id="icon-save" viewBox="0 0 1024 1024">
          <g id="copy"><path d="M857.367377 904.378575 166.632623 904.378575c-26.01142 0-47.094598-21.045315-47.094598-47.00864L119.538025 401.659963 119.538025 276.305977 119.538025 166.623925c0-25.963325 21.084201-47.004547 47.094598-47.004547L778.381441 119.619378l125.586277 126.331243 0.49221 611.420337C904.459928 883.33326 883.377774 904.378575 857.367377 904.378575zM747.475548 246.272963c0-25.958208-21.084201-47.004547-47.094598-47.004547L292.222993 199.268416c-26.01142 0-47.099714 21.046339-47.099714 47.004547l0 141.021827c0 25.963325 21.088294 47.00864 47.099714 47.00864l408.156934 0c26.010397 0 47.094598-21.045315 47.094598-47.00864L747.474524 246.272963zM794.574239 496.979912 229.425761 496.979912l0 360.391047 565.148477 0L794.574239 496.979912zM731.775984 606.665033 292.222993 606.665033 292.222993 575.326281l439.552991 0L731.775984 606.665033zM731.775984 669.340491 292.222993 669.340491 292.222993 638.003785l439.552991 0L731.775984 669.340491zM731.775984 732.017996 292.222993 732.017996 292.222993 700.68129l439.552991 0L731.775984 732.017996zM731.775984 794.6955 292.222993 794.6955l0-31.338752 439.552991 0L731.775984 794.6955zM559.096133 230.605122l94.189196 0 0 172.362626-94.189196 0L559.096133 230.605122z" p-id="2398"></path></g>
        </symbol>
        <symbol id="icon-preview" viewBox="0 0 1024 1024">
          <g id="copy"><path d="M1020.061538 494.276923C927.507692 307.2 734.523077 177.230769 512 177.230769S96.492308 307.2 3.938462 494.276923c-5.907692 11.815385-5.907692 25.6 0 35.446154C96.492308 716.8 289.476923 846.769231 512 846.769231s415.507692-129.969231 508.061538-317.046154c5.907692-11.815385 5.907692-23.630769 0-35.446154zM512 728.615385c-120.123077 0-216.615385-96.492308-216.615385-216.615385s96.492308-216.615385 216.615385-216.615385 216.615385 96.492308 216.615385 216.615385-96.492308 216.615385-216.615385 216.615385z m0-354.461539c-76.8 0-137.846154 61.046154-137.846154 137.846154s61.046154 137.846154 137.846154 137.846154 137.846154-61.046154 137.846154-137.846154-61.046154-137.846154-137.846154-137.846154z" p-id="2107"></path></g>
        </symbol>
      </defs>
    </svg>
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="margin-top:10px;">
        <div class="container clearfix" style="position: relative;">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/Claim.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Claim</span>
            </div>
          </router-link>
          
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div class="invoice">
            <div class="invoice-menu">
              <div class="info-prof" style="display: flex">
                <div class="info-prof-avatar">
                  <img v-if="userInfoList.profile_picture" :src="userInfoList.profile_picture" alt="">
                  <img v-else src="@/assets/Images/defaultavatar.jpeg" alt="">
                </div>
                <div style="margin-left:12px;display:flex;flex-direction:column">
                  <div class="info-prof-name">{{ userInfoList.nickname }}</div>
                  <div class="info-prof-offer">{{ userInfoList.job_title }}</div>
                </div>
              </div>
              <!--   切换   -->
              <a-menu
                style="width: 256px"
                :selectedKeys="selectedKeys"
                :default-selected-keys="defaultShowMenu"
                @click="tabChangeClick">
                <a-menu-item key="1">
                  <img ref="newIcon" src="@/assets/Icons/new.svg" alt="" style="width:24px;height:24px;" class="none">
                  <img ref="newIconBlue" src="@/assets/Icons/new-blue.svg" alt="" style="width:24px;height:24px;">
                  <span>Open a Claim Report</span>
                </a-menu-item>
                <a-menu-item key="2">
                  <img ref="viewIcon" src="@/assets/Icons/view-reports.svg" alt="" style="width:24px;height:24px;">
                  <img ref="viewIconBlue" src="@/assets/Icons/view-reports-blue.svg" alt="" style="width:24px;height:24px;" class="none">
                  <span>History</span>
                </a-menu-item>
              </a-menu>
            </div>
            <div class="invoice-content">
              <div v-if="contentVisible">
                <a-spin :spinning="newInvoiceSpinning" class="new-invoice">
                  <div class="new-report">
                    <div class="new-report-title" style="z-index: 99">
                      <span class="report-new">{{ invoiceStatus }}</span>
                      <span v-if="reportIdVisible" class="report-id">No.{{ invoiceId }}</span>
                    </div>
                    <div class="new-report-content" style="z-index: 99">
                      <div class="content-item first-item">
                        <span class="item-title">Type of Expense</span>
                        <a-tree-select
                          class="tree-select"
                          style="width: 356px;height:44px;"
                          :dropdown-style="{ maxHeight: '370px', overflow: 'auto' }"
                          placeholder=""
                          :allowClear="false"
                          :value="invoiceTypeName"
                          tree-default-expand-all
                          :disabled="!invoiceEditStatus"
                          @change="reimburseTypeChange"
                          :style="{color: invoiceTypeName === 'Select Type of Expense' ? '#bbbbbb' : '#000'}"
                        >
                          <a-tree-select-node :selectable="false" v-for="(item) in reimburseTypeList"
                                              :key="item.category_code" :value="item.category_code"
                                              :title="item.category_name">
                            <a-tree-select-node :selectable="false"  v-for="(sonitem) in item.son_info" :key="sonitem.category_code"
                                                :value="`${sonitem.category_code},${sonitem.category_name}`"
                                                :title="`${sonitem.category_code} - ${sonitem.category_name}`">
                                                <a-tree-select-node  v-for="(sonitem2) in sonitem.grand_son" :key="sonitem2.category_code"
                                                :value="`${sonitem2.category_code},${sonitem2.category_name}`"
                                                :title="`${sonitem2.category_code} - ${sonitem2.category_name}`">
                                              </a-tree-select-node>
                            </a-tree-select-node>
                          </a-tree-select-node>
                        </a-tree-select>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Report Name</span><span class="item-title-des"> (For future reference)</span>
                        <a-input
                          placeholder="Enter Report Name"
                          v-model="invoiceName"
                          :disabled="!invoiceEditStatus"
                        ></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Applicant</span>
                        <a-input
                          class="disabled-input"
                          :disabled="true"
                          v-model="userInfoList.legal_name"
                        ></a-input>
                      </div>
                      <div class="content-item">
                        <span class="item-title">Date of Application</span>
                        <a-input
                          class="disabled-input"
                          :disabled="true"
                          v-model="todayDate"
                        ></a-input>
                      </div>
                    </div>
                    <div
                      v-if="!tableVisible"
                      class="new-report-generate"
                      @click="invoiceGenerate"
                    >
                      <a-button>
                        <img src="@/assets/Icons/new-document.svg" alt="" style="height:16px;width:14px;margin-right:8px;margin-bottom:2px;">
                        <span>Create a New Form</span>
                      </a-button>
                    </div>
                    <!-- <div v-else class="new-report-table" style="height:1060px;"> -->
                    <div v-else class="new-report-table" style="">
                      <div v-show="printVisible" id="printBtn" class="printBtn">
                        <div class="box-id">No.{{ invoiceId }}</div>
                        <div v-if="userInfoList.employee_corp=='1'" class="box-lartl" style="margin-top:0;margin-bottom:15px;">北京嘀果技术服务有限公司</div>
                        <div v-else-if="userInfoList.employee_corp=='2'" class="box-lartl" style="margin-top:0;margin-bottom:15px;">上海嘀果技术服务有限公司</div>
                        <div v-else-if="userInfoList.employee_corp=='0'" class="box-lartl" style="margin-top:0;margin-bottom:15px;">北京金泰伦技术服务有限公司</div>
                        <div class="box-tl">员工费用报销申请单</div>
                        <div class="table" style="border:1px solid #000;">
                          <div class="tr table-top">
                            <span class="td" style="width: 13%;font-weight: bold;border-right:1px solid #000; ">申请人</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;">{{ userInfoList.legal_name }}</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;font-weight: bold; ">报销类型</span>
                            <span class="td" style="width: 55.5%;border-right:none;">{{ invoiceTypeName }}</span>
                          </div>
                           <div class="tr table-top">
                            <span class="td" style="width: 13%;font-weight: bold;border-right:1px solid #000;border-top:1px solid #000;">申请时间</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;border-top:1px solid #000;">{{ invoiceDate }}</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;font-weight: bold;border-top:1px solid #000;">报销单名称</span>
                            <span class="td" style="width: 55.5%;border-right:none;border-top:1px solid #000;">{{ invoiceName }}</span>
                          </div>
                          <div class="tr table-theader">
                            <span class="td" style="width: 13%;border-right:1px solid #000;border-top:1px solid #000;">序号</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;border-top:1px solid #000;">发票日期</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;border-top:1px solid #000;">发票类型</span>
                            <span class="td" style="width: 41%;border-right:1px solid #000;border-top:1px solid #000;">费用详情</span>
                            <span class="td" style="width: 14.5%;border-right:0;border-top:1px solid #000;">金额</span>
                          </div>
                          <div class="tr table-content" v-for="(item, index) in invoiceDataList" :key="index" style="height:28px;">
                            <span class="td" style="width: 13%;border-right:1px solid #000;border-top:1px solid #000;">{{ index + 1 }}</span>
                            <span class="td" style="width: 16%;border-right:1px solid #000;border-top:1px solid #000;">
                              <a-date-picker
                                style="margin-left: 6px;height:28px;margin-bottom:4px;"
                                v-model="item.date"
                                :allowClear="false"
                                placeholder=""
                                :disabled="!invoceDetailEditStatus"
                                @change="(date, dateString) => dataPickerChange(date, dateString, index)" />
                            </span>
                            <span class="td" style="justify-content: flex-start; width: 16%;border-right:1px solid #000;border-top:1px solid #000;">
                              <a-select
                                :show-arrow="false"
                                v-model="item.invoice_name"
                                class="type-select"
                                style="width:100%;"
                                @change="invoiceTypeChange"
                                :allowClear="false"
                                show-search
                                placeholder=""
                                :disabled="!invoceDetailEditStatus"
                              >
                                <a-select-option  v-for="item in invoiceTypeList" :key="item.invoice_code"
                                                  :value="`${index},${item.invoice_code},${item.invoice_name}`">
                                  {{ item.invoice_name }}
                                </a-select-option>
                              </a-select>
                            </span>
                            <span class="td" style="justify-content: flex-start; width: 41%;border-right:1px solid #000;border-top:1px solid #000;">
                              <a-input v-model="item.comments" style="width: 100%;height:28px;" :disabled="!invoceDetailEditStatus" />
                            </span>
                            <span class="td" style="justify-content: flex-end; width:14.5%;border-right: 0px;border-top:1px solid #000;">
                              <a-input
                                v-model="item.amount"
                                style="width: 100%; text-align: right;height:28px"
                                @blur="() => amoutBlur(item.amount, index)"
                                :disabled="!invoceDetailEditStatus"
                              />
                            </span>
                          </div>
                          <div class="tr table-result" style="border-top:1px solid #000;">
                            <span class="total-title">合计:</span>
                            <span class="total-num">￥{{ this.total }}</span>
                          </div>
                        </div>
                        <div class="invoice-check">
                          <div>
                            <div class="invoice-check-item">
                              <div>编制</div>
                              <div>日期:</div>
                            </div>
                          </div>
                          <div>
                            <div class="invoice-check-item">
                              <div>审批</div>
                              <div>日期:</div>
                            </div>
                          </div>
                          <div>
                            <div class="invoice-check-item">
                              <div>核查</div>
                              <div>日期:</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="!submitStatus">
                        <div style="margin:32px 32px 16px;" >
                          <a-textarea
                            style="min-height:80px;"
                            placeholder="发票一键粘贴，顺序为：发票日期，发票类型，费用详情，金额"
                            @change="multipleInput"
                            :autoSize="{ minRows: 4, maxRows: 6 }"
                            :disabled="!invoceDetailEditStatus"
                            />
                        </div>
                        <a style="margin:32px;margin-right:4px;" href="https://docs.google.com/spreadsheets/d/1E_d7b_SlJwKFcXbASuZbwJbuYJLWwnmcmbWWPq173qw/edit#gid=0" target="_blank">发票一键粘贴模版</a>
                        <span style="">（发票类型填写时确保与下拉框里的选项一致）</span>
                      </div>
                      <div v-show="!printVisible" class="printBtn" style="width: 736px;margin-left:32px;margin-bottom:16px;">
                        <div class="table">
                          <div class="tr table-theader edit-content">
                            <span class="td" style="width: 12.5%;">序号</span>
                            <span class="td" style="width: 15%;">发票日期</span>
                            <span class="td" style="width: 15%;">发票类型</span>
                            <span class="td" style="width: 43%;">费用详情</span>
                            <span class="td" style="width: 14.5%;border-right:0;">金额</span>
                          </div>
                          <div class="tr table-content" v-for="(item, index) in invoiceDataList" :key="index">
                            <span class="td" style="width: 12.5%;">{{ index + 1 }}</span>
                            <span class="td" style="width: 15%;">
                              <a-date-picker
                                style="margin-left: 6px;"
                                v-model="item.date"
                                :allowClear="true"
                                placeholder=""
                                :disabled="!invoceDetailEditStatus"
                                @change="(date, dateString) => dataPickerChange(date, dateString, index)" />
                            </span>
                            <span class="td" style="justify-content: flex-start; width: 15%;padding-bottom: 3px;">
                              <a-select
                                v-model="item.invoice_name"
                                :allowClear="true"
                                class="type-select"
                                style="width:100%;"
                                @change="invoiceTypeChange(index,item.invoice_name)"
                                :show-arrow="false"
                                show-search
                                placeholder=""
                                :disabled="!invoceDetailEditStatus"
                              >
                                <a-select-option class="empty-height"  v-for="item in invoiceTypeList" :key="item.invoice_code"
                                                  :value="`${index},${item.invoice_code},${item.invoice_name}`"
                                >
                                  {{ item.invoice_name }}
                                </a-select-option>
                              </a-select>
                            </span>
                            <span class="td" style="justify-content: flex-start; width: 43%">
                              <a-input v-model="item.comments" style="width: 100%" :disabled="!invoceDetailEditStatus" />
                            </span>
                            <span class="td" style="justify-content: flex-end; width:14.5%;border-right: 0px;">
                              <a-input
                                v-model="item.amount"
                                oninput="value=value.replace(/[^\d|'.']/g,'')"
                                style="width: 100%; text-align: right;padding-right:15px;"
                                @blur="() => amoutBlur(item.amount, index)"
                                :disabled="!invoceDetailEditStatus"
                              />
                            </span>
                          </div>
                          <div class="tr table-result" style="height:48px;">
                            <span class="total-title" style="color:#2177e9;">合计:</span>
                            <span v-if="this.total != ''" class="total-num">￥{{ this.total }}</span>
                          </div>
                        </div>
                        <div class="invoice-description">
                          <div class="invoice-des-title">发票类型说明:</div>
                          <div class="invoice-des-content">
                            <span class="des-item-title">1.餐费: </span>
                            <span class="des-item-content">记录就餐人员</span>
                            <br>
                            <span class="des-item-title">2.交通费: </span>
                            <span class="des-item-content">记录发生事由</span>
                            <br>
                            <span class="des-item-title">3.培训费: </span>
                            <span class="des-item-content">记录发生事由</span>
                            <br>
                            <span class="des-item-title">4.办公用品: </span>
                            <span class="des-item-content">记录采购项目</span>
                            <br>
                            <span class="des-item-title">5.食品: </span>
                            <span class="des-item-content">记录采购项目</span>
                            <br>
                            <span class="des-item-title">6.服务费: </span>
                            <span class="des-item-content">记录发生事由</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="tableVisible" class="printAndSubmit">
                      <a-button v-if="!saveStatus" @click="invoiceSubmitConfirm(0)" class="btn-save" style="margin-right:16px;">
                        <svg fill="#2177e9" width="17px" height="17px" style="margin-right:7px;"><use xlink:href="#icon-save"></use></svg>
                        <span>Save as Draft</span>
                      </a-button>
                      <a-button 
                        v-if="submitStatus && !invoiceReimburseStatus" 
                        v-print="'#printBtn'" 
                        @click="invoicePrint" 
                        class="btn-print"
                        style="margin-right:32px;justify-content:center;"
                      >
                        <svg width="17px" height="17px" fill="#ffffff" style="margin-right:7px;"><use xlink:href="#icon-print"></use></svg>
                        <span>Print Preview</span>
                      </a-button>
                      <a-popconfirm
                        title="提交后无法修改，是否继续提交？"
                        ok-text="确定"
                        cancel-text="取消"
                        @confirm="invoiceSubmitConfirm(1)"
                        @cancel="invoiceSubmitCancel"
                      >
                        <a-button v-if="!submitStatus" class="btn-submit" style="margin-right:32px;">
                          <svg fill="#ffffff" width="17px" height="17px" style="margin-right:7px;"><use xlink:href="#icon-submit"></use></svg>
                          <span>Submit Report</span>
                        </a-button>
                      </a-popconfirm>
                    </div>
                  </div>
                </a-spin>
              </div>
              <div v-else>
                <a-spin :spinning="viewInvoiceSpinning" class="view-invoice">
                  <div class="view-report">
                    <div class="view-report-title">
                      <span class="title-text">History ({{yearValue}})</span>
                      <div>
                        <a-select
                            class="year-select"
                            style="margin-right:24px;"
                            v-model="yearValue"
                            @change="yearChange"
                          >
                          <a-select-option v-for="item in yearList" :key="item" :value="item">{{item}}</a-select-option>
                        </a-select>
                        <span class="title-num">{{ invoiceUserList.length }} in Total</span>
                      </div>
                    </div>
                    <div class="view-report-content">
                      <div class="report-content-item" v-for="(item,index) in invoiceUserList" :key="index">
                        <span class="content-item-id" style="width:150px;">No.{{ item.rb_number }}</span>
                        <span class="content-item-type" style="width:200px;">{{ item.category_name }}</span>
                        <span class="content-item-name" style="width:200px;">{{ item.rb_name }}</span>
                        <span 
                          class="content-item-status" 
                          style="width:50px;"
                          :style="{
                                    color:  item.rb_status === '0' ? 'orange' : 
                                            item.rb_status === '1' ? 'gray' : 
                                            item.rb_status === '2' ? 'green' : 
                                            item.rb_status === '3' ? 'red' : 
                                            item.rb_status === '4' ? 'gray' : 'red'
                                  }"
                        >
                          {{  
                              item.rb_status == '0' ? '未提交' : 
                              item.rb_status == '1' ? '已提交' :  
                              item.rb_status == '2' ? '已通过' : 
                              item.rb_status == '3' ? '已拒绝' : 
                              item.rb_status == '4' ? '已打款' : '已驳回' 
                          }}
                        </span>
                        <span class="content-item-btn">
                          <!-- 草稿 可编辑 -->
                          <a-tooltip placement="bottom"> 
                            <template slot="title">编辑</template>
                            <span v-if="item.rb_status == '0' || item.rb_status == '5'" class="invoice-edit" @click="editInvoice(item.rb_number,item.rb_status)" style="width:20px;height:20px;margin-left:16px;">
                              <svg width="21" height="21" fill="#dddddd"><use xlink:href="#icon-edit"></use></svg>
                            </span>
                          </a-tooltip>
                          <!-- 提交 不可编辑 只可打印 -->
                          <a-tooltip placement="bottom"> 
                            <template slot="title">复制</template>
                            <span 
                              v-if="item.rb_status == '1' || item.rb_status == '2' || item.rb_status == '3' || item.rb_status == '4'" 
                              class="invoice-edit" 
                              @click="copyInvoice(item.rb_number)" 
                              style="width:20px;height:20px;margin-left:16px;"
                            >
                              <svg width="21" height="21" fill="#dddddd"><use xlink:href="#icon-copy"></use></svg>
                            </span>
                          </a-tooltip>
                          <a-popconfirm
                            title="确定删除该条报销单吗？"
                            ok-text="确认"
                            cancel-text="取消"
                            @confirm="invoiceDeleteConfirm(item.rb_number)"
                            @cancel="invoiceDeleteCancel"
                          >
                            <a-tooltip placement="bottom"> 
                              <template slot="title">删除</template>
                              <span v-if="item.rb_status == '0'" class="invoice-delete" style="width:20px;height:20px;margin-left:16px;">
                                <svg width="21" height="21" fill="#dddddd"><use xlink:href="#icon-delete"></use></svg>
                              </span>
                            </a-tooltip>
                          </a-popconfirm>
                          <a-tooltip placement="bottom"> 
                            <template slot="title">预览</template>
                            <span v-if="item.rb_status != '0'" 
                                  class="invoice-print" 
                                  @click="printInvoice(item.rb_number,item.rb_status)"
                                  style="width:20px;height:20px;margin-left:16px;"
                            >
                              <svg width="21" height="21" viewBox="0 0 512 512" fill="#bbbbbb"><use xlink:href="#icon-preview"></use></svg>
                            </span>
                          </a-tooltip>
                        </span>
                      </div>
                    </div>
                  </div>
                </a-spin>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true
let invoiceDataList = [
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },
  {
    amount: '',
    comments: '',
    type_code: '',
    invoice_name: '',
    date: '',
  },

]

export default {
  name: 'Report',
  components:{
    Bug
  },
  inject: ['reload'],
  data() {
    return {
      invoiceDataList,
      moment,                                             //  日期
      dateFormat: 'MM-DD-YYYY',                           //  日期格式
      yearValue:moment().format().slice(0, 10).split('-')[0],                                 //  今天日期
      todayDate: moment()                                 //  今天日期
      .format()
      .slice(0, 10),
      invoiceTypeList: '',                                //  发票类型
      reimburseTypeList: '',                              //  报销类型
      userInfoList: '',                                   //  个人信息
      invoiceUserList: '',                                //  所有报销单
      curUserId: '',                                      //  当前员工编号
      avatar: '',                                         //  当前员工头像                                   

      //  tab切换
      contentVisible: true,                               //  是否展示报告内容
      newInvoiceSpinning: false,                          //  新建发票内容加载状态
      viewInvoiceSpinning: false,                         //  查看发票内容加载状态
      defaultShowMenu: ['1'],                                //  默认tab页

      //  发票信息
      invoiceId: '',                                      //  发票id
      invoiceTypeId: '',                                  //  发票类型id
      invoiceTypeName: 'Select Type of Expense',          //  报销类型名称
      invoiceName: '',                                    //  发票名字
      // invoiceApplicant: 'Xiayu',                       //  申请人姓名
      invoiceDate: moment()                               //  申请日期
      .format()
      .slice(0, 10),
      total: '',                                          //  总价
      invoiceSubmitStatus:'false',                        //  发票单填写验证
      invoiceEditStatus: true,                            //  发票信息输入框编辑状态
      invoceDetailEditStatus: true,                       //  发票详情信息编辑状态
      invoiceStatus: 'New Claim Report',                  //  发票状态 编辑 修改 打印
      invoiceOperate:'',                                  //  存草稿或提交操作

      //  显示按钮或表单
      tableVisible: false,                                //  表单显示
      printVisible: false,                                //  打印页面显示
      reportIdVisible: false,                             //  报告id显示
      submitStatus: false,                                //  提交/打印按钮显示
      saveStatus: false,                                  //  保存按钮显示
      invoiceReimburseStatus:false,                       //  报销状态
      oneTapInput:true,

      selectedKeys:['1'],
    }
  },
  computed: {
    // 年列表
    yearList:function() {
      const currentYear = new Date().getFullYear();
      return [currentYear, currentYear - 1, currentYear - 2]
    },
  },
  watch: {
    '$route'() {
      this.initPage()
    }
  },
  methods: {
    //  tab 切换
    tabChangeClick(e) {
      if (e.key == 1) {
        this.$refs.newIcon.style.display = 'none'
        this.$refs.newIconBlue.style.display = 'initial'
        this.$refs.viewIcon.style.display = 'initial'
        this.$refs.viewIconBlue.style.display = 'none'

        this.invoiceStatus = 'New Claim Report'
        this.contentVisible = true
        this.tableVisible = false
        // 发票状态初始化
        this.invoiceId = ''
        this.invoiceTypeId = ''
        this.invoiceTypeName = 'Select Type of Expense'
        this.invoiceName = ''
        this.todayDate = moment().format().slice(0, 10),
        this.reportIdVisible = false
        this.invoiceEditStatus = true
        this.invoceDetailEditStatus = true
        this.submitStatus = false
        this.printVisible = false
        this.total = ''
        this.invoiceDataList = [
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
          {
            amount: '',
            comments: '',
            type_code: '',
            invoice_name: '',
            date: '',
          },
        ]

        this.selectedKeys = ['1']
        this.$router.push({ path: '/claim/new-report' })
      } else {
        this.$router.push({ path: '/claim/history' })
      }
    },
    // 获取员工信息 和 报销列表
    getUserInfo() {
      this.viewInvoiceSpinning = true
      this.$post(api.tool.getRbListByEe, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        year:this.yearValue,
        employee_id: this.curUserId,
        ee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.userInfoList = res.list.employee_info
          this.invoiceUserList = res.list.rblist
          this.viewInvoiceSpinning = false
        }
      })
    },
    //  获取发票类型
    getInvoiceTypeList() {
      this.$post(api.tool.getInvoiceType, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.invoiceTypeList = res.list
        }
      })
    },
    //  获取报销类型
    getreimburseTypeList() {
      this.$post(api.tool.getRbCategory, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.reimburseTypeList = res.list
        }
      })
    },
    //  新增报销单
    invoiceGenerate() {
      if (this.invoiceTypeName == '' || this.invoiceTypeName == 'Select Type of Expense') {
        this.$message.error('请选择报销单类型')
        return
      } else if (this.invoiceName == '') {
        this.$message.error('请输入报销单名称')
        return
      }

      // console.log('员工id:' + this.curUserId, '报销类型id:' + this.invoiceTypeId, '发票名字:' + this.invoiceName)
      this.newInvoiceSpinning = true
      // 发送请求
      this.$post(api.tool.addRbNum, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        cat_code: this.invoiceTypeId,
        rb_status:0,
        name: this.invoiceName
      }).then((res) => {
        if (res.code === 200) {
          this.invoiceId = res.list
          this.tableVisible = true
          this.reportIdVisible = true
          this.newInvoiceSpinning = false
          this.saveStatus = false
          this.$message.success('报销单创建成功')

        }
      })
    },
    //  确认提交报告单
    invoiceSubmitConfirm(operate) {
      // this.invoiceSubmitCheck(this.invoiceDataList)
      // console.log('invoiceSubmitStatus',this.invoiceSubmitStatus)
      // if(!this.invoiceSubmitStatus) {
      //    this.$message.error('请将报销单填写完整')
      // }
      // 请求
      // console.log(this.invoiceTypeId,this.invoiceName)
      // console.log('申请人id:' + this.curUserId, '报销(发票)序号:' + this.invoiceId, '发票信息:', this.invoiceDataList)
      // console.log(this.curUserId)
      // console.log(this.invoiceId)
      // console.log(this.invoiceDataList)
      // console.log(operate)
      // console.log(this.invoiceTypeId)
      // console.log(this.invoiceName)


      this.newInvoiceSpinning = true
      this.invoiceOperate = operate
      this.$post(api.tool.dealRbDetails, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        number: this.invoiceId,
        list: this.invoiceDataList,
        rb_status:operate,
        cat_code: this.invoiceTypeId,
        name: this.invoiceName
      }).then((res) => {
        if (res.code === 200) {
          if(this.invoiceOperate == 1) {
            this.invoceDetailEditStatus = false
            this.newInvoiceSpinning = false
            this.submitStatus = true
            this.saveStatus = true
            this.invoiceEditStatus = false
            this.invoiceReimburseStatus = true
            this.getInvoiceDetail()
            this.$message.success('报销单提交成功')
          }else if (this.invoiceOperate == 0) {
            this.invoceDetailEditStatus = false
            this.newInvoiceSpinning = false
            this.saveStatus = true
            this.invoiceEditStatus = false
            this.getInvoiceDetail()
            this.$message.success('报销单保存成功')
          } 
        }
      })
    },
    //  取消提交报告单
    invoiceSubmitCancel() {
      this.$message.warning('提交操作已取消')
    },
    //  获取报销单详情
    getInvoiceDetail(id,type) {
      this.selectedKeys = ['1']
      this.newInvoiceSpinning = true
      this.invoiceId = id || this.invoiceId
      this.$router.push({ path: '/claim/new-report-' + this.invoiceId })
      // console.log('申请人id:' + this.curUserId, '报销(发票)序号:' + this.invoiceId)
      this.$post(api.tool.getRbDetails, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        number: this.invoiceId,
        type:type,
      }).then((res) => {
        if (res.code === 200) {
          this.invoiceId = res.list.detail.rb_number
          this.invoiceTypeName = res.list.detail.category_code + ' - ' + res.list.detail.category_name
          this.invoiceTypeId = res.list.detail.category_code
          this.invoiceName = res.list.detail.rb_name
          this.invoiceDate = res.list.detail.addtime
          this.todayDate = res.list.detail.addtime
          this.invoiceDataList = res.list.list

          let total = 0
          let totalList = 0
          this.invoiceDataList.map((item, index) => {
            let amountList = parseFloat(item.amount).toFixed(2).split('.')
            if (amountList == 'NaN') {
              amountList = ['', '']
              totalList = ['', '']
              return
            }
            this.invoiceDataList[index].amount = '￥' + amountList[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + amountList[1]

            let amount = item.amount.replace(/,/g, '')
            if (amount) {
              total += parseFloat(amount.split('￥')[1])
            }
          })
          totalList = total.toFixed(2).split('.')
          this.total = totalList[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + totalList[1];
          
          this.newInvoiceSpinning = false
        }
      })
    },
    //  打印
    invoicePrint() {
      this.printVisible = true
    },
   reimburseTypeChange(item) {
      this.invoiceTypeId = item.split(',')[0]
      // this.invoiceTypeName = item.split(',')[1]
      this.invoiceTypeName = item.split(',')[0] + ' - ' + item.split(',')[1]
    },
    //  发票时间改变
    dataPickerChange(date, dateString, index) {
      this.invoiceDataList[index].date = dateString
      console.log(dateString)
    },
    //  发票类型改变
    invoiceTypeChange(index,item) {
      if(item == undefined) {
        this.invoiceDataList[index].type_code = ''
        this.invoiceDataList[index].invoice_name = ''
      }else {
        this.invoiceDataList[item.split(',')[0]].type_code = item.split(',')[1]
        this.invoiceDataList[item.split(',')[0]].invoice_name = item.split(',')[2]
      }
      
    },
    //  金额改变
    amoutBlur(amount, index) {
      let amountList = parseFloat(amount.replace(',','')).toFixed(2).split('.')
      if(amount == '') {
        this.invoiceDataList[index].amount = ''
      }else if(amount.indexOf('￥') != -1) {
        return
      }else {
        this.invoiceDataList[index].amount = '￥' + amountList[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + amountList[1]
      }

      let total = 0
      this.invoiceDataList.forEach((item) => {
        let amount = item.amount.replace(/,/g, '')
        if (amount) {
          total += parseFloat(amount.split('￥')[1])
        }
      })
      let totalList = total.toFixed(2).split('.')
      this.total = totalList[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + totalList[1]
    },

    multipleInput(e) {
      let res = e.target.value.split('\n')
      console.log(res)
      // let status = false
      this.invoiceDataList.forEach((item,index) => {
        if(res[index] !== undefined) {
          let resSingle = res[index].split('\t');
          this.invoiceDataList[index].date = resSingle[0]
          this.invoiceDataList[index].invoice_name = resSingle[1]
          this.invoiceTypeList.forEach(item => {
            if(item.invoice_name == resSingle[1]) {
              this.invoiceDataList[index].type_code = item.invoice_code
            }
          })
          this.invoiceDataList[index].comments = resSingle[2]
          // console.log(res[3])
          this.amoutBlur(resSingle[3],index)
          // status = true;
        }else {
          this.invoiceDataList[index].date = ''
          this.invoiceDataList[index].invoice_name = ''
          this.invoiceDataList[index].type_code = ''
          this.invoiceDataList[index].comments = ''
          this.amoutBlur('',index)
        }
      })
    },
    //  修改发票
    editInvoice(id,status) {
      this.tabChangeClick({ key: 1 })
      this.invoiceStatus = 'New Claim Report'
      this.tableVisible = true
      this.reportIdVisible = true
      this.submitStatus = false
      this.printVisible = false
      if(status == 5) {
        this.saveStatus = true
        this.invoiceEditStatus = false
      }else {
        this.invoiceEditStatus = true
        this.saveStatus = false
      }
      
      this.invoceDetailEditStatus = true

      this.getInvoiceDetail(id,'')
    },
    //  复制发票
    copyInvoice(id) {
      this.tabChangeClick({ key: 1 })
      this.invoiceStatus = 'New Claim Report'
      this.tableVisible = true
      this.reportIdVisible = true
      this.submitStatus = false
      this.printVisible = false
      this.saveStatus = false

      this.invoceDetailEditStatus = true
      this.invoiceEditStatus = true
      this.getInvoiceDetail(id,'copy')
    },
    //  确认删除发票
    invoiceDeleteConfirm(id) {
      this.$post(api.tool.deleteRb, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        number: id,
      }).then((res) => {
        if (res.code === 200) {
          this.getUserInfo()
          this.$message.success('报销单删除成功')
        }
      })
    },
    //  取消删除发票
    invoiceDeleteCancel() {
      this.$message.warning('删除操作已取消')
    },
    //  打印发票
    printInvoice(id,status) {
      this.tabChangeClick({ key: 1 })
      this.invoiceStatus = 'Print Claim Report'
      this.tableVisible = true
      this.reportIdVisible = true
      this.submitStatus = true
      this.printVisible = true
      this.saveStatus = true

      this.invoceDetailEditStatus = false
      this.invoiceEditStatus = false
      this.getInvoiceDetail(id,'')

      if(status == 1 || status == 3 || status == 5 ) {
        this.invoiceReimburseStatus = true
      }else if (status == 2 || status == 4 ) {
        this.invoiceReimburseStatus = false
      }
    },

    yearChange() {
      this.viewInvoiceSpinning = true
      this.$post(api.tool.getRbListByEe, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        year:this.yearValue,
        employee_id: this.curUserId,
        ee_id: this.curUserId,
      }).then((res) => {
        if (res.code === 200) {
          this.invoiceUserList = res.list.rblist
          this.viewInvoiceSpinning = false
        }
      })
    },

    // 路由 - 初始化页面
    initPage() {
      if(this.$route.params.category == undefined || this.$route.params.category == 'new-report') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'none'
          this.$refs.newIconBlue.style.display = 'initial'
          this.$refs.viewIcon.style.display = 'initial'
          this.$refs.viewIconBlue.style.display = 'none'
        })
        this.selectedKeys = ['1']
      }else if(this.$route.params.category == 'history') {
        this.$nextTick(() => {
          this.$refs.newIcon.style.display = 'initial'
          this.$refs.newIconBlue.style.display = 'none'
          this.$refs.viewIcon.style.display = 'none'
          this.$refs.viewIconBlue.style.display = 'initial'
        })
        this.contentVisible = false
        this.getUserInfo()
        this.selectedKeys = ['2']
      }
    }
  },
  created() {
    if (localStorage.impr_id) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id

      this.getUserInfo()
      this.getInvoiceTypeList()
      this.getreimburseTypeList()

      this.initPage()
    } else {
      this.$router.push({ path: '/login' })
    }
  },
}
</script>

<style scoped>

/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
.container {
  /*width: 60%;*/
  width: 1120px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1a73e8;
}

/* tab */
.invoice {
  min-height: 1091px;
  width: 100%;
  margin-top: 40px;
  display: flex;
}
.invoice-menu {
  width: 320px;
  display: flex;
  flex-direction: column;
}
#components-layout-demo-basic >>> .ant-menu-vertical {
  border-right: 0;
  margin-top: 24px;
}
#components-layout-demo-basic >>> .ant-menu-item {
  height: 44px;
  width: 280px;
  background-color: #ffffff;
  border-radius: 0 22px 22px 0;
}
#components-layout-demo-basic >>> .ant-menu-item span {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #222222;
  margin-left: 16px;
}
#components-layout-demo-basic >>> .ant-menu-item-selected {
  background-color: #e9f0fd;
  border-radius: 0 22px 22px 0;
}
#components-layout-demo-basic >>> .ant-menu-item-selected span {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #1a73e8;
}
#components-layout-demo-basic >>> .tree-select .ant-select-arrow i svg {
  display: none;
}
#components-layout-demo-basic >>> .tree-select .ant-select-arrow {
    /* display: none; */
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 9px solid #2177e9;
    border-radius: 3px;
}

/* avatar name */
.info-prof {
  height: 81px;
}
.info-prof-avatar {
  margin-top: 5px;
  margin-left: 4px;
  width: 72px;
  height: 72px;
}
.info-prof-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;

}
.info-prof-name {
  height: 16px;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  line-height: 19px;
  color: #222222;
  margin-top: 23px;
}
.info-prof-offer {
  height: 12px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  line-height: 19px;
  color: #555555;
  margin-top: 10px;
}

#printBtn {
  /*border: 1px solid red;*/
  width: 660px;
  margin: 0 auto;
}

/* content */
.invoice-content {
  display: flex;
  flex-direction: column;
}
.new-report {
  min-height: 422px;
  width: 800px;
  box-shadow: 0px 0px 12px 1px rgba(17, 17, 17, 0.06);
  border-radius: 8px;
  margin-bottom:30px;
}
.new-report-title {
  display: flex;
  justify-content: space-between;
  height: 85px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;

  color: #222222;

}
.new-report-title .report-new {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  margin-top: 22px;
  margin-left: 31px;
}
.new-report-title .report-id {
  font-family: GoogleSans-Regular;
  font-size: 16px;
  margin-top: 40px;
  margin-right: 33px;
}
.new-report-content {
  height: 222px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 24px;
}
.content-item {
  height: 67px;
  width: 356px;
  margin-bottom: -10px;
}
.content-item.first-item {
  display: flex;
  flex-direction: column;
}
#components-layout-demo-basic >>> .ant-select-selection {
  margin-top: 8px;
  height: 40px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  /*color: #bbbbbb;*/
  background-color: transparent;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding-left: 6px;
}
#components-layout-demo-basic >>> .type-select .ant-select-selection {
  padding-left: 0px;
  height: 28px;
}
#components-layout-demo-basic >>> .type-select .ant-select-selection__rendered {
  line-height: 36px;
}
#components-layout-demo-basic >>> .ant-select-disabled .ant-select-selection {
  background: transparent;
}

#components-layout-demo-basic >>> .tree-select.ant-select-disabled .ant-select-selection.ant-select-selection--single,
#components-layout-demo-basic >>> .content-item .ant-input.ant-input-disabled {
  background-color: #fafafa;
  color: #999999;
}
#components-layout-demo-basic >>> .ant-select-selection--single .ant-select-selection__rendered {
  line-height: 36px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  /*color: #222222;*/
}
#components-layout-demo-basic >>> .year-select .ant-select-selection__rendered {
  margin-right:36px;
  line-height:38px;
}
#components-layout-demo-basic >>> .content-item span {
  height: 40px;
  font-size: 14px;
  line-height: 19px;
  border-radius: 8px;
}
#components-layout-demo-basic >>> .content-item span.item-title {
  color: #999999;
  height: 40px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  line-height: 19px;
  /* color: #999999; */
  border-radius: 8px;
}
#components-layout-demo-basic >>> .content-item span.item-title-des {
  font-size: 12px;
  color:#999999;
}
#components-layout-demo-basic >>> .tree-select.ant-select.ant-select-disabled .ant-select-selection__rendered {
  color: #999999;
}
#components-layout-demo-basic >>> .content-item .ant-input {
  margin-top: 10px;
  height: 40px;
  font-family: GoogleSans-Regular;
  font-size: 14px;
  color: #222222;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding-left: 16px;
}
#components-layout-demo-basic >>> .ant-input.disabled-input {
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
}
#components-layout-demo-basic >>> .ant-select-selection__placeholder {
  color: #bbbbbb;
}
#components-layout-demo-basic >>> .ant-input::placeholder {
  color: #bbbbbb;
}
.new-report-generate {
  padding-top: 32px;
  padding-left: 32px;
  cursor: pointer;
}
#components-layout-demo-basic >>> .new-report-generate .ant-btn {
  width: 735px;
  height: 48px;
  background-color: #2177e9;
  border-radius: 8px;
  border: 1px solid #2177e9;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #ffffff;
}
#components-layout-demo-basic >>> .printBtn .ant-input.ant-input-disabled {
  /*background-color: #ffffff;*/
  border: 0;
}

/* table */
.box-lartl {
  color: #000;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
.box-tl {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.table {
  margin-top: 32px;
  border: 1px solid #eeeeee;
  border-radius: 8px 8px 8px 8px;
}
.tr.table-top {
  /*border-bottom: 1px solid #eeeeee;*/
}
.tr.table-theader {
  height: 40px;
}
.tr.table-content {
  height: 32px;
}
.tr.table-result {
  height: 40px;
  border-top: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.total-title {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #000000;
  margin-left: 27px;
}
.total-num {
  font-family: GoogleSans-Bold;
  font-size: 16px;
  color: #000000;
  margin-right: 20px;
  font-weight: bold;
}
.invoice-des-title {
  font-family: GoogleSans-Bold;
  font-size: 14px;
  color: #666666;
  margin-top: 31px;
}
.invoice-des-content {
  margin-top: 18px;
}
.des-item-title {
  font-family: GoogleSans-Bold;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
}
.des-item-content {
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #666666;
}

.table-theader.edit-content {
  background-color: #f5f5f5;
}
.table-top .td {
  border-right: 1px solid #eeeeee;
}
.table-theader .td {
  border-right: 1px solid #eeeeee;
  font-family: GoogleSans-Bold;
  font-size: 14px;
  color: #222222;
  font-weight: 700;
}
.table-content .td {
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  /* font-family: PingFangSC-Regular; */
  font-size: 13px;
  color: #222222;
}

.printAndSubmit {
  border-top: 1px solid #eeeeee;
  height: 98px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.btn-print,
.btn-submit {
  height: 48px;
  width: 173px;
  border: 2px solid #2177e9;
  border-radius: 8px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #ffffff;
  background-color: #2177e9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-save {
  height: 48px;
  width: 173px;
  border: 2px solid #2177e9;
  border-radius: 8px;
  font-family: GoogleSans-Medium;
  font-size: 14px;
  color: #2177e9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-save:hover {
  color: #ffffff;
  border: 2px solid #2177e9;;
  background-color: #2177e9;
} 
.btn-save:hover svg {
  fill: #ffffff;
}

.invoice-check {
  height: 60px;
  display: flex;
  justify-content: space-between;
  margin-top: 44px;
  /*padding-top:30px;*/
}

.invoice-check-item {
  width: 120px;
  border-top: 1px solid #000;
  font-family: GoogleSans-Medium;
  font-weight: bold;
  font-size: 14px;
}

#components-layout-demo-basic >>> .ant-calendar-picker-input {
  /* font-family: PingFangSC-Regular; */
  font-size: 14px;
  color: #222222;
  border: 0;
}
#components-layout-demo-basic >>> .type-select .ant-select-selection {
  border: 0;
  margin-top: 0;
}
#components-layout-demo-basic >>> .tree-select .ant-select-selection__rendered {
  padding-top: 10px;
}
#components-layout-demo-basic >>> .type-select .ant-select-selection__rendered {
  /*font-family: GoogleSans-Bold;*/
  font-size: 13px;
  color: #222222;
  line-height: 32px;
}

.tr {
  display: flex;
  width: 100%;
  position: relative;
}
.td {
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  height: 32px;
  padding: 0 8px;
  font-size: 13px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theader {
  display: flex;
  width: 100%;
  height: 60px;
  justify-content: flex-end;
}
.theader .td {
  height: 60px;
  line-height: 1.2;
  text-align: center;
  font-weight: bold;
}
.ttop .td {
  height: 35px;
}
.box-tl {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.box-lartl {
  color: #000;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 24px;
}
.box-id {
  margin-top: 20px;
  font-family: GoogleSans-Medium;
  font-size: 16px;
  color: #999999;
}

#components-layout-demo-basic >>> .printBtn .ant-input {
  border-width: 0;
  background: none;
  font-size: 13px;
  color: #000;
  padding: 0;
  line-height: 32px;
}
#components-layout-demo-basic >>> .printBtn .ant-input:focus,
#components-layout-demo-basic >>> .printBtn .ant-select-selection:focus {
  border-color: #fff;
  border-right-width: 0 !important;
  outline: 0;
  box-shadow: none;
}
#components-layout-demo-basic >>> .printBtn .ant-input:hover,
#components-layout-demo-basic >>> .printBtn .ant-select-selection:hover {
  border-color: #fff;
  border-right-width: 0 !important;
}
#components-layout-demo-basic >>> .printBtn .ant-select-selection {
  border-width: 0;
  color: #000;
}
#components-layout-demo-basic >>> .printBtn .ant-select-selection__rendered {
  display: flex;
  justify-content: center;
  margin-left: 10px;
}
#components-layout-demo-basic >>> .printBtn .type-select .ant-select-selection__rendered .ant-select-selection-selected-value {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
#components-layout-demo-basic >>> .printBtn .ant-calendar-picker-icon {
  display: none;
}
#printBtn .ant-calendar-picker-icon {
  display: none;
}

.tr {
  height: 44px;
  border: 0;
}
.td {
  height: 100%;
  border: 0;

}

.view-report {
  width: 800px;
}
.view-report-title {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.title-text {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}
.title-num {
  font-family: GoogleSans-Bold;
  font-size: 16px;
  color: #2177e9;
}
.view-report-content {
  margin-top: 25px;
}
.report-content-item {
  border: 1px solid #eeeeee;
  border-radius: 8px;
  background-color: #ffffff;
  padding-left: 24px;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px
}
.content-item-id {
  font-family: GoogleSans-Bold;
  font-size: 14px;
  color: #222222;
}
.content-item-type {
  font-family: GoogleSans-Regular;
  font-size: 14px;
  color: #222222;
}
.content-item-btn {
  display: flex;
  justify-content: flex-end;
  width: 116px;
  padding-right: 24px;
}
.content-item-name {
  font-family: GoogleSans-Regular;
  font-size: 14px;
  color: #999999;
}
.invoice-edit,
.invoice-delete,
.invoice-print {
  cursor: pointer;
}
.invoice-edit:hover svg,
.invoice-delete:hover svg,
.invoice-print:hover svg {
  fill: #2177e9;
}
#components-layout-demo-basic >>> .ant-calendar-picker-clear {
  right:-5px;
}
#components-layout-demo-basic >>> .ant-select-selection__clear {
  right:8px;
  font-size: 14px;
}
.none {
  display: none;
}
</style>
